<div class="sidebar" [class.collapsed]="collapsed()">
  <ul class="nav flex-column">

    @for (item of menuItems; track $index) {

    @if (item.hasAccess) {
    <li class="m-2">
      <!-- Item sem submenu -->
      @if(!item.children) {
      <a class="nav-link d-flex align-items-center px-3" [routerLink]="item.route" routerLinkActive="active">
        <i class="me-2" [ngClass]="item.icon"></i>
        @if(!collapsed()) {
        <span>{{ item.label }}</span>
        }
      </a>

      }

      <!-- Item com submenu -->
      @else {
      @if (item.hasAccess) {
      <div class="submenu">
        <div class="pointer nav-link d-flex align-items-start justify-content-between"
          (click)="toggleSubmenu(item.label)">
          <div class="d-flex align-items-center">
            <i class="me-2" [ngClass]="item.icon"></i>
            @if(!collapsed()) {
            <span>{{ item.label }}</span>
            }
          </div>
          @if(!collapsed()) {
          <i class="" [ngClass]="{
                'bi-chevron-down': isSubmenuExpanded(item.label),
                'bi-chevron-right': !isSubmenuExpanded(item.label)
              }">
          </i>
          }
        </div>

        @if(isSubmenuExpanded(item.label) && !collapsed()) {
        <ul class="nav flex-column ms-3 mt-1">
          @for (child of item.children; track $index; let last = $last) {
          @if (child.hasAccess) {
          <li [ngClass]="{'last-customized': last &&  item.label === 'Configurações'}">
            @if (!child.children?.length) {
            <a class="nav-link d-flex align-items-center" [routerLink]="child.route" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}">
              @if (child.icon) {
              <i class="me-2" [ngClass]="child.icon"></i>
              }
              <span>{{ child.label }}</span>
            </a>
            } @else {
            <div class="submenu">
              <div class="pointer nav-link d-flex align-items-start justify-content-between"
                (click)="toggleSubmenu(child.label)">
                <div class="d-flex align-items-center">
                  @if (child.icon) {
                  <i class="me-2" [ngClass]="child.icon"></i>
                  }
                  <span>{{ child.label }}</span>
                </div>
                @if(!collapsed()) {
                <i class="" [ngClass]="{
                      'bi-chevron-down': isSubmenuExpanded(child.label),
                      'bi-chevron-right': !isSubmenuExpanded(child.label)
                    }">
                </i>
                }
              </div>
              @if (isSubmenuExpanded(child.label)) {
              <ul class="nav flex-column ms-3 mt-1">
                @for (grand of child.children; track $index) {
                @if (grand.hasAccess) {
                <li>
                  <a class="nav-link d-flex align-items-center" [routerLink]="grand.route" routerLinkActive="active">
                    @if (grand.icon) {
                    <i class="me-2" [ngClass]="grand.icon"></i>
                    }
                    <span>{{ grand.label }}</span>
                  </a>
                </li>
                }
                }
              </ul>
              }
            </div>
            }
          </li>
          }
          }
        </ul>
        }

      </div>
      }
      }

    </li>
    }
    }

  </ul>
</div>
